// EditCategory.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './EditCategory.css';
import { baseUrl } from '../components/constant';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const EditSubCategory = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedCategory, subcategory } = location.state || {};
  const [name, setName] = useState(subcategory ? subcategory.name.en : '');
  const [nameAr, setNameAr] = useState(subcategory ? subcategory.name.ar : '');
  const [NewImageView, setNewImageView] = useState('');
  const [newImage, setNewImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
    const [imageUrl, setImageUrl] = useState(subcategory ? subcategory.photo : '');
  
  console.log("subcategory", subcategory)
  useEffect(() => {
    if (!subcategory) {
      navigate('/SubCategories');
    }
  }, [subcategory, navigate]);


  const handleSave = async (e) => {
    e.preventDefault();
    setError('')
    if (!name) {
      toast.error('Please enter a category name.');
      return;
    }
    if (!nameAr) {
      toast.error('Please enter a category name arabic');
      return;
    }
    if (!imageUrl) {
      toast.error('Please select an image.');
      return;
    }
    setLoading(true);

    try {
      const token = JSON.parse(localStorage.getItem('token'));
      if (!token) {
        toast.error('You are not authenticated.');
        return;
      }
      const formData = new FormData();
      formData.append('name[en]', name);
      formData.append('name[ar]', nameAr);
      if (NewImageView) {
        formData.append('photo', newImage);
      }

      console.log("formData",formData)
      // Check and append parent_id to the formData
      const response = await fetch(baseUrl + `/categories/update-subcategories/${subcategory.id}`, {
        method: 'POST', 
        headers: {
          'Accept': 'application/json',
          'x-api-key': 'web-app',
          "Authorization": 'Bearer ' + token,
        },
        body: formData,
      });

      const data = await response.json();
      console.log("data", data)
      if (response.ok) {
        toast.success('Edited successfully');
        navigate('/SubCategories');// Redirect to the home page within the root layout
      } else {
        if (data.errors) {
          if (data.errors.name) {
            toast.error(data.errors.name[0]);
          }
        }
      }
    } catch (err) {
      console.log("err", err)
      // Handle network or unexpected errors
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };
const handleImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      if (!validTypes.includes(file.type)) {
        toast.error('Please select a valid image file (jpeg, jpg, png).');
        return;
      }

      setImageUrl(file); // Store the file object
      setNewImage(file); // Store the file object
      setNewImageView(URL.createObjectURL(event.target.files[0]));
    }
  };




  return (
    <div style={{ width: '100%' }}>
      <h2 style={{ color: "#e02828", textAlign: 'center' }}>Edit subcategory</h2>
      <div className="edit-category-container">
        {loading && (
          <div className="loader-overlay">
            <div className="loader"></div>
          </div>
        )}
        <div className="edit-category">
          {/* <h2 style={{color:"#e02828"}}>{name}</h2> */}

          <div className="form-group">
            <label htmlFor="imageUrl">Image</label>
            <div className="image-preview">
              <img src={NewImageView || `https://dashboard.onyxen-regalia.com/backend/storage/${imageUrl}`} alt="Category" className="category-image" />
              <label htmlFor="imageUpload" className="edit-image" style={{ backgroundColor: "rgb(154, 57, 57)" }}>
                Edit
              </label>
              <input
                type="file"
                id="imageUpload"
                accept="image/*"
                onChange={handleImageChange}
                style={{ display: 'none' }}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="name">SubCategory name english</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={{
                backgroundColor: "#fff", fontSize: 20, width: "70%",
                padding: '10px',
                border: '1px solid #717171',
                borderRadius: '8px', color: "#000"
              }}
            />
          </div>
          <div className="form-group">
          <label htmlFor="name">SubCategory name arabic</label>
            <input
              type="text"
              id="name"
              value={nameAr}
              onChange={(e) => setNameAr(e.target.value)}
              style={{
                backgroundColor: "#fff", fontSize: 20, width: "70%",
                padding: '10px',
                border: '1px solid #717171',
                borderRadius: '8px', color: "#000"
              }}
            />
          </div>
          <div className="form-buttons">
            <button onClick={handleSave} style={{ backgroundColor: "rgb(154, 57, 57)" }}>Save</button>
            <button onClick={() => navigate('/Categories')} style={{ backgroundColor: "#000" }}>Cancel</button>
          </div>
        </div>
      </div>
    </div>

  );
};

export default EditSubCategory;
